import { combineReducers } from 'redux';
import indicatorSlice from './landscapeAPI/indicator/reducers/indicator.slice';
import themeSlice from './landscapeAPI/theme/reducers/theme.slice';
import goalSlice from './landscapeAPI/goal/reducers/goal.slice';
import collectionSlice from './landscapeAPI/collection/reducers/collection.slice';
import verificationStatusSlice from './landscapeAPI/verificationStatus/reducers/verification-status.slice';
import projectSlice from './landscapeAPI/project/reducers/project.slice';
import projectSupportSlice from './landscapeAPI/project/reducers/project-support.slice';
import projectTargetSlice from './landscapeAPI/project/reducers/project-target.slice';
// import newsletterFormSlice from './contextAPI/newsletter/reducers/newsletter-form.slice';
// import documentSlice from './landscapeAPI/document/reducers/document.slice';
// import contactFormSlice from './contextAPI/contactForm/reducers/contact-form.slice';
import goalCollectionSlice from './landscapeAPI/goal/reducers/goalCollection.slice';
import userSlice from './contextAPI/user/reducers/user.slice';
import eventLoggingSlice from './contextAPI/eventLogging/reducers/event-logging.slice';
import indicatorProjectSlice from './landscapeAPI/indicator/reducers/indicatorProject.slice';
import indicatorGoalSlice from './landscapeAPI/indicator/reducers/indicatorGoal.slice';
// import indicatorThemeSlice from './landscapeAPI/indicator/reducers/indicatorTheme.slice';
import goalThemeSlice from './landscapeAPI/goal/reducers/goalTheme.slice';
import landscapeSlice from './landscapeAPI/landscape/reducers/landscape.slice';
import landscapeContactPersonSlice from './landscapeAPI/landscape/reducers/landscape-contact-person.slice';
import landscapeIndicatorSlice from './landscapeAPI/landscape/reducers/landscape-indicator.slice';
import commoditySlice from './tradeAPI/commodity/reducers/commodity.slice';
import entityGalleryTileSlice from './landscapeAPI/galleryTile/reducers/entity-gallery-tile.slice';
import linkSlice from './landscapeAPI/link/reducers/link.slice';
import locationSlice from './landscapeAPI/location/reducers/location.slice';
import targetSlice from './landscapeAPI/value/reducers/target.slice';
import participantSlice from './landscapeAPI/participant/reducers/participant.slice';
import buyerSlice from './buyerAPI/buyer/reducers/buyer.slice';
import mediaDocumentSlice from './mediaAPI/document/reducers/document.slice';
import mediaSlice from './mediaAPI/media/reducers/media.slice';
import landscapeDocumentSlice from './landscapeAPI/landscape/reducers/landscape-document.slice';
import userRoleSlice from './contextAPI/user/reducers/user-role.slice';
import roleSlice from './contextAPI/role/reducers/role.slice';
import commodityLandscapeSlice from './tradeAPI/commodity/reducers/commodity-landscape.slice';
import storySlice from './landscapeAPI/story/reducers/story.slice';
import buyerDocumentSlice from './buyerAPI/buyer/reducers/buyer-document.slice';
import landscapeSupportersSlice from './tradeAPI/commodity/reducers/landscape-supporters.slice';
import projectSupporterSlice from './tradeAPI/projectSupporter/reducers/project-supporters.slice';
import blockSlice from './landscapeAPI/block/reducers/block.slice';
import projectCommoditySlice from './tradeAPI/projectCommodity/reducers/project-commodity.slice';
import translateSlice from './translateAPI/translate/reducers/translate.slice';
// import highlightedStorySlice from './landscapeAPI/story/reducers/highlighted-story.slice';
import organizationBlockSlice from './buyerAPI/block/reducers/block.slice';
import contributionSlice from './landscapeAPI/value/reducers/contribution.slice';
import baselineSlice from './landscapeAPI/value/reducers/baseline.slice';
import typeSlice from './landscapeAPI/landscape_types/reducers/type.slice';

const rootReducer = combineReducers({
  userSlice,
  goalSlice,
  indicatorSlice,
  indicatorProjectSlice,
  indicatorGoalSlice,
  // indicatorThemeSlice,
  themeSlice,
  collectionSlice,
  verificationStatusSlice,
  projectSlice,
  projectSupportSlice,
  projectTargetSlice,
  // newsletterFormSlice,
  // contactFormSlice,
  // documentSlice,
  goalCollectionSlice,
  goalThemeSlice,
  eventLoggingSlice,
  landscapeSlice,
  landscapeContactPersonSlice,
  landscapeIndicatorSlice,
  commoditySlice,
  entityGalleryTileSlice,
  linkSlice,
  locationSlice,
  targetSlice,
  participantSlice,
  buyerSlice,
  mediaDocumentSlice,
  mediaSlice,
  landscapeDocumentSlice,
  userRoleSlice,
  roleSlice,
  commodityLandscapeSlice,
  storySlice,
  buyerDocumentSlice,
  landscapeSupportersSlice,
  projectSupporterSlice,
  blockSlice,
  projectCommoditySlice,
  translateSlice,
  // highlightedStorySlice,
  organizationBlockSlice,
  contributionSlice,
  baselineSlice,
  typeSlice,
});

export default rootReducer;
